module.exports = __webpack_public_path__ + "static/media/MC.0244095d.png";